import { render, staticRenderFns } from "./menpiaoTongji.vue?vue&type=template&id=d8d5da04&scoped=true&"
import script from "./menpiaoTongji.vue?vue&type=script&lang=js&"
export * from "./menpiaoTongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d5da04",
  null
  
)

export default component.exports